var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldLifebuoy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33 9.41 5.325 6.404a1 1 0 0 0-1.585.228C2.56 8.795 1.97 10.585 1.97 12c0 2.49.91 4.77 2.42 6.52l3.438-3.43a1 1 0 0 0 .208-1.114C7.679 13.173 7.5 12.515 7.5 12c0-.96.31-1.85.83-2.59zM14.59 8.33l2.979-2.978a1 1 0 0 0-.228-1.585C15.182 2.59 13.392 2 11.97 2c-2.49 0-4.76.91-6.51 2.42l3.416 3.425a1 1 0 0 0 1.12.205c.81-.367 1.478-.55 2.004-.55.96 0 1.85.31 2.59.83zM15.81 9.696c.46.946.69 1.713.69 2.302 0 .98-.32 1.88-.85 2.62l3.443 3.443a.5.5 0 0 0 .787-.105c1.394-2.43 2.09-4.415 2.09-5.958 0-2.49-.91-4.76-2.42-6.51l-3.644 3.635a.5.5 0 0 0-.096.573zM9.38 15.648l-3.474 3.473a.5.5 0 0 0 .105.787c2.43 1.394 4.416 2.09 5.958 2.09 2.5 0 4.78-.91 6.52-2.43l-3.646-3.646a.5.5 0 0 0-.57-.098c-.939.45-1.697.674-2.274.674-.98 0-1.88-.32-2.62-.85z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldLifebuoy);
export default __webpack_public_path__ + "static/media/vuesax-bold-lifebuoy.d0e9673caeab39e93a797d151895555c.svg";
export { ForwardRef as ReactComponent };